var map = {
	"./10-12-2020-v2/1024/img/Body_DiffuseColor.png": "7f6c",
	"./10-12-2020-v2/2048/img/Body_DiffuseColor.png": "a464",
	"./10-12-2020-v2/512/img/Body_DiffuseColor.png": "eb50",
	"./10-12-2020-v3/1024/img/Body_DiffuseColor.png": "ac87",
	"./10-12-2020-v3/2048/img/Body_DiffuseColor.png": "e864",
	"./10-12-2020-v3/512/img/Body_DiffuseColor.png": "9aa4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4a77";